module.exports = __webpack_public_path__ + "img/email.f335a02e.svg";